export const template = (term, data) => {
    const { name, count } = data;
    return `<li class="c-autocomplete__result">
        <span>${term} (${count})</span>
        <span>${name}</span>
    </li>`;
};

export const createResult = (term, data) => {
    let element = document.createElement("template");
    element.innerHTML = template(term, data);
    return element.content.firstChild;
};

export const createNoResults = () => {
    let element = document.createElement("template");
    element.innerHTML = `<li class="c-autocomplete__no-results">No results</li>`;
    return element.content.firstChild;
};

export default template;